module.exports = __webpack_public_path__ + "static/media/instructor-onboarding-welcome-round1.304e5540.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-onboarding-welcome-round1.mp4
// module id = 2655
// module chunks = 0